import React, {PureComponent} from "react"
import ESIInclude from 'jl-esi-components'

export class WishListLoader extends PureComponent {

  constructor (props) {
    super (props)
  }

  render(){
    const {sku, skuSelected, dataProductDetails} = this.props;
    return (
      <div id="add-to-wish-list-esi" data-sku={sku} data-sku-selected={skuSelected} data-product-details={dataProductDetails} >
        <ESIInclude id="add-to-wishlist-component" src="/add-to-wishlist/exclude-cpa.html?includeCoreJS=false&includePolyfills=false" />
      </div>)
  }
}
